<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements";
  import type { Snippet } from "svelte";
  import { cn } from "$lib/utils/cn";

  type Props = HTMLAttributes<HTMLDivElement> & {
    class?: string;
    children?: Snippet;
    compact?: boolean;
    flush?: boolean;
  };

  const { class: className, children, compact = false, flush = false, ...rest }: Props = $props();
</script>

<div class={cn("surface-card", !flush && (compact ? "p-4" : "p-6"), className)} {...rest}>
  {@render children?.()}
</div>
